import React from 'react';
import {
    FormControl, InputLabel
} from "@deere/fuel-react";
import {Controller} from "react-hook-form";
import TextField from "@material-ui/core/TextField";

export const FormText = ({desc, name, value, control}) => {
    return (
        <FormControl fullWidth>
            <InputLabel htmlFor={name}>{desc}</InputLabel>
            <Controller
                rules={{required: false}}
                control={control}
                defaultValue={value}
                value={value}
                name={name}
                render={({onChange, value}) => (
                    <TextField
                        id={name}
                        onChange={(e) => {
                            onChange(e);
                        }}
                        value={value}
                        InputProps={{
                            readOnly: true,
                            disableUnderline: true
                        }}
                        size="small"
                        variant="standard"
                    />
                )}
            />
        </FormControl>
    );
};
